import { AUTHENTICATION_SCOPES } from '../../context/IdentityContext'
import { AuthenticationResult, PublicClientApplication } from '@azure/msal-browser'
import { isOfficeInitialized } from '../../helpers/outlookHelper'
import { useState } from 'react'

export default function useAcquireBootstrapToken() {
    const [tokenRequest, setTokenRequest] = useState<Promise<string>>()

    return (username: string, pca: PublicClientApplication, handleBootstrapToken): Promise<string> => {
        if (tokenRequest) {
            return tokenRequest
        }

        const account =
            pca.getAllAccounts().find(account => account.username.toLowerCase() === username) || pca.getActiveAccount()
        console.log(`Current available number of accounts ${pca.getAllAccounts()?.length}.`)
        if (isOfficeInitialized()) {
            console.log(`Attempt to acquire token through Outlook for account ${username}.`)
            const request = Office.auth
                .getAccessToken({ allowConsentPrompt: true, allowSignInPrompt: true })
                .then((result: string) => handleBootstrapToken(result))
                .catch(e => {
                    console.log(e)
                    return Promise.reject(e)
                })
                .finally(() => {
                    // Remove the promise once done.
                    setTokenRequest(undefined)
                })
            setTokenRequest(request)
            return request
        } else if (account) {
            // Acquire the bootstrap token silently.
            // This is possible when MSAL has already stored the authentication of the current user.
            console.log(`Attempt to silently acquire token for selected account ${account.username}.`)
            const request = pca
                .acquireTokenSilent({ scopes: AUTHENTICATION_SCOPES, account })
                .then((result: AuthenticationResult) => handleBootstrapToken(result.accessToken))
                .catch(e => {
                    console.log(e)
                    console.log(`Redirect user ${account.username} to get a token.`)
                    return pca
                        .acquireTokenRedirect({
                            scopes: AUTHENTICATION_SCOPES,
                        })
                        .then(() => '')
                        .catch(e => {
                            console.log(e)
                            return Promise.reject(e)
                        })
                })
                .finally(() => {
                    // Remove the promise once done.
                    setTokenRequest(undefined)
                })
            setTokenRequest(request)
            return request
        } else {
            // Acquire the bootstrap token through a redirect.
            console.log(`Redirect user for a new bootstrap token.`)
            return pca
                .acquireTokenRedirect({ scopes: AUTHENTICATION_SCOPES })
                .then(() => '')
                .catch(e => {
                    console.log(e)
                    return Promise.reject(e)
                })
        }
    }
}
